import { Base, createApp } from '@studiometa/js-toolkit';
import Header from './components/Header.js';
import Product from './components/Product/index.js';

globalThis.$root = null;

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      '.shopify-section--header': Header,
      Product
    },
  };

  mounted() {
    globalThis.$root = this;
  }
}

export default createApp(App, document.body);
